module.exports = __webpack_public_path__ + "img/post-add.e565dcc8.svg";